export const BILLING_CREDITS = Object.freeze({
    'analysis.ai': 1
});

export const DEFAULT_REQUIRED_CREDITS = 0;
